import RunningTrade from 'global/MainLayout/SideWidget/RunningTrade';
import BaseModal from 'global/Modal/BaseModal';
import styled from 'styled-components';

export const Modal = styled(BaseModal)`
  & .ant-modal-content {
    height: 90vh;
    border-radius: 4px;
  }

  & .ant-modal-body {
    padding: 0;
    border-radius: 4px;
    overflow: hidden;

    height: 100vh;
    max-height: 100%;
  }
`;

export const FastRunningTrade = styled(RunningTrade)`
  height: 100% !important;
  width: 100%;
  overflow: hidden;

  & > div {
    height: 100% !important;

    & > div:last-of-type {
      height: 100% !important;
    }
  }
`;
